import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import { API } from "../lib/api";

const MemberContext = createContext();

export const MemberProvider = ({ children }) => {
  const [member, setMember] = useState(null);
  const [memberLoading, setMemberLoading] = useState(true);
  const token = localStorage.getItem("member_token");

  useEffect(() => {
    if (token) {
      axios.get(`${API}/member/me`, { headers: { Authorization: `Bearer ${token}` } })
        .then(res => setMember(res.data))
        .catch(() => { localStorage.removeItem("member_token"); setMember(null); })
        .finally(() => setMemberLoading(false));
    } else {
      setMemberLoading(false);
    }
  }, [token]);

  const memberLogin = (tokenVal, userData) => {
    localStorage.setItem("member_token", tokenVal);
    setMember(userData);
  };

  const memberLogout = () => {
    localStorage.removeItem("member_token");
    setMember(null);
  };

  const getMemberHeader = () => {
    const t = localStorage.getItem("member_token");
    return t ? { Authorization: `Bearer ${t}` } : {};
  };

  return (
    <MemberContext.Provider value={{ member, memberLoading, memberLogin, memberLogout, getMemberHeader }}>
      {children}
    </MemberContext.Provider>
  );
};

export const useMember = () => useContext(MemberContext);
